/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Producto from "./Componentes/Detalle_Producto";
import Home_Articulos from "./Componentes/Home_Articulos";
import Detalle_Relacionados from "./Componentes/Detalle_Relacionados";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {useParams} from "react-router";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Seccion_Detalle = () => {
    const parms = useParams();
    const [producto, setProducto] = useState({});

    useEffect(() => {
        irArriba()
        if (parms && parms.id){
            obtenerDoc('productos', parms.id).then(dox => {
                if (dox.res){
                    setProducto(dox.data);
                }
            })
        }

    },[parms])

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Detalle_Producto item={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 12, mb: 12}}>
                <Detalle_Relacionados item={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 18}}>
                <Home_Articulos/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle    